export default {
      id: "link-usage",
      viewBox: "0 0 285.6 282",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#link",
      toString: function () {
        return this.url;
      }
    }